import React, { Component } from "react"
import PropTypes from "prop-types"
import { Helmet, HelmetProvider } from "react-helmet-async"
import cx from "classnames"
import { window } from "browser-monads"

import Header from "./header/header"
import Footer from "./footer/footer"
//import CookieNotice from "./cookies/cookieNotice"
import Popup from "./popup/popup"
import ExitIntentPopup from "./popup/exitIntentPopup"
import { client, GraphqlContext } from "../graphql/client"
import { getHreflang } from "../helpers/getHreflang"

import "../_global/index.scss"
import "./layout.module.scss"

const pagePath = window?.location?.href
const market = getHreflang()

class Layout extends Component {
  render() {
    return (
      <HelmetProvider>
        <Helmet>
          <script type="text/javascript" src="/js/modernizr.js" defer></script>
          <script type="text/javascript" id="vwoCode">
            {`window._vwo_code || (function() {
            var account_id=341386,
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();`}
          </script>

          {/* for english, spanish, australian, portuguese, french, japanese homepage hreflang settings */}
          {this?.props?.home && (
            <>
              <link rel="alternate" href={pagePath} hreflang={market} />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace("/es", "/au")
                    : market === "en-au"
                    ? pagePath.replace("/au", "/es")
                    : market === "pt"
                    ? pagePath.replace("/pt", "")
                    : market === "fr"
                    ? pagePath.replace("/fr", "")
                    : market === "jp"
                    ? pagePath.replace("/jp", "")
                    : market === "en"
                    ? `${pagePath}au`
                    : pagePath
                }
                hreflang={
                  market === "es"
                    ? "en-au"
                    : market === "en-au"
                    ? "es"
                    : market === "en"
                    ? "en-au"
                    : market === "fr"
                    ? "en-au"
                    : market === "jp"
                    ? "en-au"
                    : "en"
                }
              />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace("/es", "")
                    : market === "en-au"
                    ? pagePath.replace("/au", "")
                    : market === "pt"
                    ? pagePath.replace("/pt", "es")
                    : market === "fr"
                    ? pagePath.replace("/fr", "es")
                    : market === "jp"
                    ? pagePath.replace("/jp", "es")
                    : market === "en"
                    ? `${pagePath}es`
                    : pagePath
                }
                hreflang={
                  market === "es"
                    ? "en"
                    : market === "en-au"
                    ? "en"
                    : market === "pt"
                    ? "es"
                    : market === "fr"
                    ? "es"
                    : market === "jp"
                    ? "es"
                    : market === "en"
                    ? "es"
                    : "en"
                }
              />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace("/es", "/pt")
                    : market === "en-au"
                    ? pagePath.replace("/au", "/pt")
                    : market === "en"
                    ? `${pagePath}pt`
                    : market === "pt"
                    ? pagePath.replace("/pt", "/au")
                    : market === "fr"
                    ? pagePath.replace("/fr", "/pt")
                    : market === "jp"
                    ? pagePath.replace("/jp", "/pt")
                    : pagePath
                }
                hreflang={
                  market === "es"
                    ? "pt"
                    : market === "en-au"
                    ? "pt"
                    : market === "en"
                    ? "pt"
                    : market === "pt"
                    ? "en-au"
                    : market === "fr"
                    ? "es"
                    : market === "jp"
                    ? "es"
                    : "en"
                }
              />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace("/es", "")
                    : market === "en-au"
                    ? pagePath.replace("/au", "")
                    : market === "pt"
                    ? pagePath.replace("/pt", "")
                    : market === "fr"
                    ? pagePath.replace("/fr", "")
                    : market === "jp"
                    ? pagePath.replace("/jp", "")
                    : pagePath
                }
                hreflang="x-default"
              />
            </>
          )}

          {/* translations */}
          {this?.props?.translations && (
            <>
              <link rel="alternate" href={pagePath} hreflang={market} />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace(`${this?.props?.esPathUrl}`, `${this?.props?.auPathUrl}`)
                    : market === "en-au"
                    ? pagePath.replace(`${this?.props?.auPathUrl}`, `${this?.props?.esPathUrl}`)
                    : market === "pt"
                    ? pagePath.replace(`${this?.props?.ptPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "en"
                    ? `${this?.props?.auPathUrl}`
                    : market === "fr"
                    ? pagePath.replace(`${this?.props?.frPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "jp"
                    ? pagePath.replace(`${this?.props?.jpPathUrl}`, `${this?.props?.enPathUrl}`)
                    : pagePath
                }
                hreflang={
                  market === "es"
                    ? "en-au"
                    : market === "en-au"
                    ? "es"
                    : market === "pt"
                    ? "en"
                    : market === "en"
                    ? "en-au"
                    : market === "fr"
                    ? "en"
                    : market === "jp"
                    ? "en"
                    : "en"
                }
              />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace(`${this?.props?.esPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "en-au"
                    ? pagePath.replace(`${this?.props?.auPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "pt"
                    ? pagePath.replace(`${this?.props?.ptPathUrl}`, `${this?.props?.esPathUrl}`)
                    : market === "en"
                    ? `${this?.props?.esPathUrl}`
                    : market === "fr"
                    ? pagePath.replace(`${this?.props?.frPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "jp"
                    ? pagePath.replace(`${this?.props?.jpPathUrl}`, `${this?.props?.enPathUrl}`)
                    : pagePath
                }
                hreflang={
                  market === "es"
                    ? "en"
                    : market === "en-au"
                    ? "en"
                    : market === "pt"
                    ? "es"
                    : market === "en"
                    ? "es"
                    : market === "fr"
                    ? "en"
                    : market === "jp"
                    ? "en"
                    : "en"
                }
              />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace(`${this?.props?.esPathUrl}`, `${this?.props?.ptPathUrl}`)
                    : market === "en-au"
                    ? pagePath.replace(`${this?.props?.auPathUrl}`, `${this?.props?.ptPathUrl}`)
                    : market === "pt"
                    ? pagePath.replace(`${this?.props?.ptPathUrl}`, `${this?.props?.auPathUrl}`)
                    : market === "en"
                    ? `${this?.props?.ptPathUrl}`
                    : market === "fr"
                    ? pagePath.replace(`${this?.props?.frPathUrl}`, `${this?.props?.ptPathUrl}`)
                    : market === "jp"
                    ? pagePath.replace(`${this?.props?.jpPathUrl}`, `${this?.props?.ptPathUrl}`)
                    : pagePath
                }
                hreflang={
                  market === "es"
                    ? "pt"
                    : market === "en-au"
                    ? "pt"
                    : market === "en"
                    ? "pt"
                    : market === "pt"
                    ? "en-au"
                    : market === "fr"
                    ? "pt"
                    : market === "jp"
                    ? "pt"
                    : "en"
                }
              />
              <link
                rel="alternate"
                href={
                  market === "es"
                    ? pagePath.replace(`${this?.props?.esPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "en-au"
                    ? pagePath.replace(`${this?.props?.auPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "pt"
                    ? pagePath.replace(`${this?.props?.ptPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "fr"
                    ? pagePath.replace(`${this?.props?.frPathUrl}`, `${this?.props?.enPathUrl}`)
                    : market === "jp"
                    ? pagePath.replace(`${this?.props?.jpPathUrl}`, `${this?.props?.enPathUrl}`)
                    : pagePath
                }
                hreflang="x-default"
              />
            </>
          )}
        </Helmet>
        <GraphqlContext.Provider value={{ client }}>
          <Header theme={this.props.theme || "default"} translations={this.props?.translations} />
          <main data-theme={this.props.theme} className={cx("main", this.props.className)}>
            {this.props.children}
          </main>
          <Footer />
          <Popup />
          <ExitIntentPopup />
        </GraphqlContext.Provider>
      </HelmetProvider>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.objectOf(PropTypes.any),
}

export default Layout
